import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardTitle, Row, Col, Collapse, Input, Label } from "reactstrap"
import Nouislider from 'nouislider-react'
import 'nouislider/distribute/nouislider.css'
import wNumb from 'wnumb'
import { isMobile } from 'react-device-detect'

const Filters = ({
  showRangePrice,
  minPrice,
  maxPrice,
  setPriceRange,
  showSuppliers,
  suppliers,
  supplierChecked,
  showFamilies,
  families,
  familyChecked,
  showCategories,
  categories,
  categoryChecked,
  showSubcategories,
  subcategories,
  subcategoryChecked,
  showBrands,
  brands,
  brandChecked,
}) => {
  const [openFilters, setOpenFilters] = useState(false)
  const toggleFilters = () => setOpenFilters(!openFilters)

  useEffect(() => {
    if (!isMobile) {
      setOpenFilters(true)
    }
  }, [])

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            {!isMobile && (
              <CardTitle className="mb-4">
                Filtros
              </CardTitle>
            )}

            {isMobile && (
              <Row>
                <Col>
                  <CardTitle className="mb-4" onClick={toggleFilters}>
                    Filtros
                  </CardTitle>
                </Col>
                <Col style={{ textAlign: 'right' }}>
                  <button
                    onClick={toggleFilters}
                    className="btn btn-primary mo-mb-2"
                    type="button"
                    style={{ cursor: "pointer" }}
                  >
                    {openFilters ? 'Cerrar' : 'Abrir'}
                  </button>
                </Col>
              </Row>
            )}
            <Collapse isOpen={openFilters}>

              {showRangePrice && (
                <div className="mt-4 pt-3">
                  <h5 className="font-size-14 mb-4">Precio Vendora</h5>
                  <br />
                  <Nouislider
                    range={{ min: minPrice, max: maxPrice === 0 ? 1 : maxPrice }}
                    tooltips={true}
                    format={wNumb({ decimals: 0 })}
                    start={[minPrice, maxPrice]}
                    onChange={setPriceRange}
                    connect
                    step={1}
                  />
                </div>
              )}

              {showSuppliers && (
                <div className="mt-4 pt-3">
                  <h5 className="font-size-14 mb-3">Proveedores</h5>
                  {suppliers && suppliers.map((item, key) => (
                    <div key={key} className="custom-control custom-checkbox mt-2">
                      <Input
                        type="checkbox"
                        value={item.id}
                        className="custom-control-input cursor-pointer"
                        id={`supplierCheck-${item.id}`}
                        onChange={(e) => supplierChecked(e, item)}
                      />
                      <Label className="custom-control-label cursor-pointer" htmlFor={`supplierCheck-${item.id}`}>{item.nombreComercial}</Label>
                    </div>
                  ))}
                </div>
              )}

              {showBrands && (
                <div className="mt-4 pt-3">
                  <h5 className="font-size-14 mb-3">Marcas</h5>
                  {brands && brands.map((item, key) => (
                    <div key={key} className="custom-control custom-checkbox mt-2">
                      <Input
                        type="checkbox"
                        value={item.id}
                        className="custom-control-input cursor-pointer"
                        id={`brandCheck-${item.id}`}
                        onChange={(e) => brandChecked(e, item)}
                      />
                      <Label className="custom-control-label cursor-pointer" htmlFor={`brandCheck-${item.id}`}>{item.name}</Label>
                    </div>
                  ))}
                </div>
              )}

              {showFamilies && (
                <div className="mt-4 pt-3">
                  <h5 className="font-size-14 mb-3">Familias</h5>
                  {families && families.map((item, key) => (
                    <div key={key} className="custom-control custom-checkbox mt-2">
                      <Input
                        type="checkbox"
                        value={item.id}
                        className="custom-control-input cursor-pointer"
                        id={`familyCheck-${item.id}`}
                        onChange={(e) => familyChecked(e, item)}
                      />
                      <Label className="custom-control-label cursor-pointer" htmlFor={`familyCheck-${item.id}`}>{item.name}</Label>
                    </div>
                  ))}
                </div>
              )}

              {showCategories && (
                <div className="mt-4 pt-3">
                  <h5 className="font-size-14 mb-3">Categorías</h5>
                  {categories && categories.map((item, key) => (
                    <div key={key} className="custom-control custom-checkbox mt-2">
                      <Input
                        type="checkbox"
                        value={item.id}
                        className="custom-control-input cursor-pointer"
                        id={`categoryCheck-${item.id}`}
                        onChange={(e) => categoryChecked(e, item)}
                      />
                      <Label className="custom-control-label cursor-pointer" htmlFor={`categoryCheck-${item.id}`}>{item.name}</Label>
                    </div>
                  ))}
                </div>
              )}

              {showSubcategories && (
                <div className="mt-4 pt-3">
                  <h5 className="font-size-14 mb-3">Subcategorías</h5>
                  {subcategories && subcategories.map((item, key) => (
                    <div key={key} className="custom-control custom-checkbox mt-2">
                      <Input
                        type="checkbox"
                        value={item.id}
                        className="custom-control-input cursor-pointer"
                        id={`subcategoryCheck-${item.id}`}
                        onChange={(e) => subcategoryChecked(e, item)}
                      />
                      <Label className="custom-control-label cursor-pointer" htmlFor={`subcategoryCheck-${item.id}`}>{item.name}</Label>
                    </div>
                  ))}
                </div>
              )}
            </Collapse>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

Filters.defaultProps = {
  showRangePrice: true,
  showFamilies: true,
  showCategories: true,
  showSubcategories: true,
  showBrands: true,
  showSuppliers: true
}

export default Filters
